///
/// EarthBrowser
///
/// Migration v35 to v36: Add tour/orbit camera settings
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v35 to v36
 *
 * Changes:
 * - Seeds earthbrowser.tourSettings (auto-orbit off, 45 s idle delay,
 *   0.02 rad/s orbit speed) for the camera director's idle-orbit feature.
 */
interface StateV35 {
	earthbrowser?: {
		tourSettings?: unknown
	}
}

export function migrateV35toV36(state: unknown): unknown {
	const s = state as StateV35 | null | undefined
	if (!s?.earthbrowser || s.earthbrowser.tourSettings !== undefined) return state

	return {
		...s,
		earthbrowser: {
			...s.earthbrowser,
			tourSettings: {
				autoOrbit: false,
				idleDelaySeconds: 45,
				orbitSpeed: 0.02,
			},
		},
	}
}
